import script from "./NoteDetail-page.vue?vue&type=script&lang=ts&setup=true"
export * from "./NoteDetail-page.vue?vue&type=script&lang=ts&setup=true"

import "./NoteDetail-page.vue?vue&type=style&index=0&id=d7adc7d4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7adc7d4"]])

export default __exports__